import experimentRepository from "./experiment/experimentRepository";
import wellPlatesRepository from "@/api/omni3/v1/wellplates/wellPlatesRepository";
export default {
    experiments: experimentRepository,
    wellPlates: wellPlatesRepository
};
